module.exports = __webpack_public_path__ + "static/img/202302.9e33286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/202302.jpg
// module id = /TVM
// module chunks = 0